import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const rakebackPoints = createAsyncThunk(
  "rakebackPoints/rakebackPoints",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("rakeback/rakeback-points", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const rakebackPointsSlice = createSlice({
  name: "rakebackPoints",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(rakebackPoints.pending, (state) => {
        state.loading = true;
      })
      .addCase(rakebackPoints.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(rakebackPoints.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default rakebackPointsSlice.reducer;
